import { render, staticRenderFns } from "./BookingRedirect.vue?vue&type=template&id=b152e986"
import script from "./BookingRedirect.vue?vue&type=script&lang=js"
export * from "./BookingRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports